// File: client/src/variant/cardEffects/turnFlow.js
//
// Turn/hand-flow effects whose onPlay directive is fully defined now; the engine
// wiring that consumes swapControl / tradeHands lands in Milestone 6.
//
//   'reverse'      -> board rotates 180°, player takes over the opponent's side.
//                     We emit swapControl; the variant layer flips orientation and
//                     which color the player controls (the chess engine is unchanged
//                     — DESIGN PRINCIPLE #1).
//   'trade_hands'  -> swap the two players' card hands.

export const reverse = {
  kind: 'reverse',
  onPlay: ({ card }) => ({
    swapControl: true,
    message: `${card.name}: the board flips — you now play the other side!`,
  }),
};

export const tradeHands = {
  kind: 'trade_hands',
  onPlay: ({ card }) => ({
    tradeHands: true,
    message: `${card.name}: hands swapped with your opponent.`,
  }),
};
